import api from "../../utils/api";

const EVENTS_URL = "/nps/events";
const EVALUATIONS_URL = "/nps/evaluations";
const METRICS_URL = "/nps/metrics";

export const getNpsEvents = async () => {
  const response = await api.get(EVENTS_URL);
  return response.data;
};

export const updateNpsEvent = async (id, data) => {
  const response = await api.put(`${EVENTS_URL}/${id}`, data);
  return response.data;
};

export const getEvaluationsHistory = async () => {
  const response = await api.get(EVALUATIONS_URL);
  return response.data;
};

export const getPendingEvaluations = async () => {
  const response = await api.get(`${EVALUATIONS_URL}/pending`);
  return response.data;
};

export const dismissEvaluation = async (id) => {
  const response = await api.post(`${EVALUATIONS_URL}/${id}/dismiss`);
  return response.data;
};

export const submitEvaluation = async (id, data) => {
  const response = await api.put(`${EVALUATIONS_URL}/${id}`, data);
  return response.data;
};

export const getNpsMetrics = async (params = {}) => {
  const response = await api.get(METRICS_URL, { params });
  return response.data;
};
